import {createSelector} from "reselect";
import {getOrganizationsState} from "../../store/organizations-store-selectors";

export const getOrganizationCreateModalState = createSelector(getOrganizationsState, state => state.create);
export const getOrganizationCreateModalError = createSelector(getOrganizationCreateModalState, state => state.error);

export const isOrganizationCreateInProcess = createSelector(getOrganizationCreateModalState, state => state.inProcess);
export const isOrganizationCreateModalActive = createSelector(getOrganizationCreateModalState, state => state.toggle);
